import { MutationTypes } from 'buyerapp/store/mutation-types'
import BaseActions from 'baseapp/store/actions'
import ApiUtil from '@/apis/apiutil'

export default {
  ...BaseActions,
  async getShoppingCartList ({
    commit,
    state,
    getters
  }) {
    if (!getters.isLogin) {
      console.warn('getShoppingCartList not login')
      return
    }
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      let data = await api.getCartSkuList()
      let cartList = data['skuList']
      console.log('init cartList success')
      cartList.forEach((cartItem) => { cartItem.isChecked = true })
      commit(MutationTypes.SET_SHOPPINGCART, cartList)
    } catch (error) {
      console.error('getCartSkuList failed:' + error)
    }
  },
  async updateShoppingCartSku ({
    commit,
    state,
    getters
  }, cartSku, lastCount) {
    if (!getters.isLogin) {
      console.warn('updateShoppingCartSku not login')
      cartSku.count = lastCount
      commit(MutationTypes.UPDATE_SHOPPINGCART, cartSku)
      return
    }
    console.log('updateShoppingCartSku cartSku:' + JSON.stringify(cartSku))
    let apiUtil = new ApiUtil(this)
    let api = apiUtil.getMisBuyerApi()
    try {
      let data = await api.updateCartSku(cartSku.skuid, cartSku.count)
      let skuInfo = data['sku']
      console.log('updateShoppingCartSku sku:' + JSON.stringify(skuInfo))
      Object.assign(cartSku, skuInfo)
      commit(MutationTypes.UPDATE_SHOPPINGCART, cartSku)
    } catch (error) {
      console.error('updateShoppingCartSku failed:' + error.message)
      cartSku.count = lastCount
      commit(MutationTypes.UPDATE_SHOPPINGCART, cartSku)
    }
  },
  async deleteShoppingCartSku ({
    commit,
    state,
    getters
  }, cartSkus) {
    let skuids = Array.from(cartSkus, (skuItem) => skuItem.skuid)
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      await api.delCartSkuBatch(skuids)
    } catch (error) {
      console.error('deleteShoppingCartSku failed: ' + error)
    }
    commit(MutationTypes.REMOVE_SHOPPINGCART, cartSkus)
  },
  async getCustomCompanyConfig ({
    commit,
    state,
    getters}) {
    if (!getters.isLogin) {
      console.warn('getCustomCompanyConfig not login')
      return null
    }
    if (state.customCompanyConfig) {
      return state.customCompanyConfig
    }

    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      let data = await api.getCustomCompanyConfig()
      state.customCompanyConfig = data.config
      return data.config
    } catch (error) {
      console.error('getCustomCompanyConfig failed: ' + error)
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/buyerapp/store/actions.js